import React, { useEffect, useState } from "react";
import { image } from "../../../data/image";
import NavigationBarForDesktop from "./NavigationBarForDesktop";
import NavigationBarForMobile from "./NavigationBarForMobile";
import { RxHamburgerMenu } from "react-icons/rx";
import NavContact from "./NavContact";
import { useLocation } from "react-router-dom";

export default function NavigationBar() {
  const [openMenu, setOpenMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Detect scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="w-full">
      {/* ✅ Make NavContact Fixed on Top */}
      <div className="fixed md:flex hidden top-0 left-0 w-full z-50 bg-black">
        <NavContact />
      </div>

      {/* ✅ Push Navbar Down to Prevent Overlap */}
      <nav
        className={`fixed md:top-9 top-0 left-0 w-full z-40 transition-all duration-300 ${
           isScrolled || location.pathname !== "/" ? "bg-black/70 text-white backdrop-blur-md" : "bg-transparent text-white"
        }`}
      >
        <div className="flex justify-between items-center px-6 py-4 max-w-screen-xl mx-auto">
          {/* Logo */}
          <a href="/" className="md:w-[40%] w-1/3 ">
            <img
              src={image?.logo}
              alt="logo"
              className="md:max-h-14 max-h-10 h-auto"
              onError={() => console.log("Logo image is missing!")}
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex w-3/4 justify-end">
            <NavigationBarForDesktop />
          </div>

          {/* Mobile Navigation & Toggle Button */}
          <div className="md:hidden">
            <button onClick={() => setOpenMenu(true)} className="focus:outline-none">
              <RxHamburgerMenu className="w-8 h-8 text-white hover:text-[#B9FD50] transition" />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {openMenu && <NavigationBarForMobile setOpenMenu={setOpenMenu} />}
      </nav>
    </div>
  );
}
